import { BsInput, BsTextArea, BsSelectBox } from '@MyLib/Bootstrap/BsForm.jsx';
import { BsButton } from '@MyLib/Bootstrap/BsUI.jsx';
import { BsEditableText } from "@MyLib/Bootstrap/BsEditableText.jsx";
import { BsCheckBox } from "@MyLib/Bootstrap/BsForm.jsx";

export const MyInput = BsInput;
export const MyTextArea = BsTextArea;
export const MySelectBox = BsSelectBox;

export const MyButton = BsButton;

export const MyEditableText = BsEditableText;

export const MyCheckBox = BsCheckBox;
